<template>
    <div class="serve-box">
        <!-- <img src="https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/serve.jpg" alt="123" class="servetestimg" v-prlx="{ reverse: true }"> -->
        <div class="img-box">
            <!-- 蒙版区域 -->
            <div class="maskingBOX" v-prlx>
                <div class="masking-box" ref='masking' :style='serveData.masking.maskingTransiton'>service</div>
            </div>
            <!-- 文字内容区域 -->
            <div class="text-box" ref='textBox' v-prlx="{ reverse: true }">
                <div class="left-box">
                    <!-- 行走的线 -->
                    <div class="animetionLine"></div>
                    <div class="left-center-box">
                        <div class="mobile-img"></div>
                        <div class="title">全渠道数字营销</div>
                        <h3 class="caption">Marketing<span class="showdown">Service</span></h3>
                        <div class="chinese-box" v-html='chinese'></div>
                        <div class="english-box" v-html='english'></div>
                    </div>
                    <!-- 向下导航 -->
                    <div class="toDown"><i class="iconfont icon-jiantou1"></i></div>
                </div>
                <div class="right-box"><a class="myPATH" href="/program"></a></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Serve',
        data() {
            return {
                chinese: '<p>提供谷歌、海外社交媒体、邮件营销、视频营销等全渠道客户开发服务，以及跨境人才孵化等服务。帮助外贸企业触达精准客户，建立数字营销的线上客户池。</p>',
                english: '<p>We provide a broad range of services in Google SEO, Google SEM, social media, email marketing, and solutions for sales promotions.</p>',
                serveData: {
                    masking: {
                        place: '',
                        maskingTransiton: {
                            transform: `rotate(90deg) translateX(40%)`
                        },
                    }
                },
                offsetHeight: '',//视口的高度

            }
        },
        mounted() {
            // this.onscrill()
        },
        methods: {
            toPath() {

            }
        }
    }
</script>
<style scoped>
    @import url('../../../font/ifont/iconfont.css');

    .serve-box {
        padding-bottom: 620px;
        position: relative;
        /* overflow: hidden; */
    }

    .img-box {
        position: relative;
        height: 1209px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/serve.jpg') no-repeat center;
        background-attachment: fixed;
        background-size: cover;
    }

    .text-box {
        min-width: 64.16%;
        min-height: 862px;
        display: grid;
        grid-template-columns: 88.7% 1fr;
        position: absolute;
        right: 0;
        bottom: -362px;
        background-color: #ffffff;
        /* transform: translateY(72%); */
        transition: all 0.5s;
    }

    .text-box:hover .right-box::after {
        letter-spacing: 10px;
        transform: rotate(-90deg) translateY(-100%);
    }

    .text-box:hover .right-box::before {
        width: 0%;
    }

    .left-box {
        padding: 74px 66px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        background-color: #ffffff;
    }

    .left-box::before {
        content: 'Blue  Whale';
        display: block;
        color: #E5E5E5;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
        transform: rotate(90deg);
        position: absolute;
        top: 124px;
        left: 30px;
    }

    .left-center-box {
        max-width: 558px;
    }

    .right-box {
        background-color: #1C1C1C;
        position: relative;
    }

    .myPATH {
        display: block;
        width: 100%;
        height: 100%;
    }

    .right-box::after {
        content: 'MORE';
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 35%;
        color: #ffffff;
        font-size: 16px;
        font-weight: 400;
        transform: rotate(-90deg);
        z-index: 3;
        transition: all 0.5s;
    }

    .right-box::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background-color: #1C2015;
        opacity: 0.9;
        transition: all 0.5s;
        z-index: 2;
    }

    .title {
        font-size: 24px;
        font-weight: bold;
        line-height: 137.5%;
        color: rgba(36, 136, 248, 1);
    }

    .caption {
        font-size: 64px;
        font-weight: 500;
        line-height: 117%;
        color: rgba(51, 51, 51, 1);
        margin: 16px 0 62px 0;
    }

    .showdown {
        font-size: 64px;
        font-weight: bold;
        line-height: 100%;
        color: #ffffff;
        -webkit-text-stroke: 2px rgba(112, 112, 112, 1);
        text-stroke: 2px rgba(112, 112, 112, 1);
        padding-left: 15px;
        font-family: gilroybold4;
    }

    .chinese-box>>>p {
        font-size: 16px;
        font-weight: bold;
        line-height: 250%;
        color: rgba(102, 102, 102, 1);
    }

    .english-box {
        margin-top: 38px;
    }

    .english-box>>>p {
        font-size: 16px;
        font-weight: 400;
        line-height: 214%;
        color: rgba(153, 153, 153, 1);
    }

    .animetionLine {
        width: 46px;
        height: 14px;
        position: absolute;
        top: 210px;
        left: 50px;
        transform: rotate(90deg);
        overflow: hidden;
        /* background-color:red; */
    }

    .animetionLine::after {
        content: '';
        display: block;
        transform: rotate(90deg);
        width: 1px;
        height: 46px;
        background-color: #E5E5E5;
        position: absolute;
        top: -110%;
        right: 50%;
        animation: linearMotion 2.5s infinite;
    }

    .masking-box {
        width: 1071px;
        height: 759px;
        color: #F1F1F1;
        background-color: #000000;
        opacity: 0.3;
        transform: rotate(90deg) translateX(40%);
        font-size: 230px;
        font-weight: 500;
        text-transform: uppercase;
        position: absolute;
        display: flex;
        align-items: flex-end;
        padding-left: 130px;
        top: 0px;
        left: 50px;
        /* transform: translateY(-50%); */
        transition: all 0.5s;
    }

    .toDown {
        position: absolute;
        bottom: -20px;
        left: 87px;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: rotate(90deg);
    }

    .toDown::before {
        content: '';
        display: block;
        width: 90px;
        height: 1px;
        background-color: #707070;
        border: none;
        margin-right: 33px;
    }

    .toDown .icon-jiantou1 {
        font-size: 25px;
        font-weight: bold;
        color: #707070;
    }
    .mobile-img{
        display: none;
    }
    /* .servetestimg{
        height: 1100px;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
    } */

    /* 线条运动 */
    @keyframes linearMotion {
        from {
            right: 150%;
        }

        to {
            right: -52%;
        }
    }

    @media(max-width:1185px) {
        .masking-box {
            width: 1071px;
            height: 759px;
            color: #F1F1F1;
            background-color: #000000;
            opacity: 0.3;
            transform: rotate(90deg) translateX(40%);
            font-size: 230px;
            font-weight: 500;
            text-transform: uppercase;
            position: absolute;
            display: flex;
            align-items: flex-end;
            padding-left: 130px;
            top: 0px;
            left: -162px;
            /* transform: translateY(-50%); */
            transition: all 0.5s;
        }
    }

    @media(max-width: 995px) {
        .serve-box {
            padding-bottom: 0;
        }

        .left-box::before,
        .animetionLine,
        .masking-box,
        .toDown,
        .right-box {
            display: none;
        }

        .title {
            text-align: center;
        }

        .caption,
        .showdown {
            font-size: 24px;
            margin: 2% 0;
            text-align: center;
        }

        .showdown {
            -webkit-text-stroke: 1px rgba(112, 112, 112, 1);
            text-stroke: 1px rgba(112, 112, 112, 1);
        }

        .img-box {
            position: static;
            height: auto;
            background: #fff url('');
        }

        .text-box {
            min-width: 100%;
            max-width: 100%;
            min-height: 100%;
            display: grid;
            grid-template-columns: 1fr;
            position: relative;
            right: 0;
            bottom: 0%;
        }

        .left-box {
            padding: 0%;
        }

        .left-center-box {
            max-width: 100%;
        }
        .chinese-box{
            padding:0 5%;
        }

        .english-box {
            margin-top: 0px;
            padding:5%;
        }
        .mobile-img{
            display: block;
            background: #ffffff url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/serve.jpg') no-repeat center;
            background-size: cover;
            width: 100%;
            height: 50vw;
        }


        /* 

        .left-box {
            padding: 0;
            background-color: transparent;
        }

        .left-center-box {
            max-width: 90%;
            background-color: #ffffff;
            padding: 5%;
        }

        .serve-box {
            padding-bottom: 320px;
        }

        .toDown {
            display: none;
        }

        .right-box {
            display: none;
        }

        .caption {
            margin: 5% 0;
        } */
    }

    /* @media(max-width: 1023px) {
        .serve-box {
            padding-bottom: 1020px;
        }

        .text-box {
            min-width: 100%;
            grid-template-columns: 90% 1fr;
            padding: 0 2%;
            background-color: transparent;
            bottom: -70%;
        }

        .left-box::before {
            display: none;
        }

        .left-box {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            position: relative;
        }

        .left-center-box {
            max-width: 100%;
        }

        .img-box {
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/serve.jpg') no-repeat center;
            background-attachment: initial;
            background-size: cover;
        }

        .title {
            font-size: 50px;
            line-height: 137%;
            margin-bottom: 2%;
        }

        .caption {
            font-size: 75px;
            font-family: gilroybold4;
            margin-top: 2;
        }

        .showdown {
            font-size: 75px;
            font-family: gilroybold4;
            font-weight: normal;
            line-height: 100%;
            -webkit-text-stroke: 1px rgba(112, 112, 112, 1);
            text-stroke: 1px rgba(112, 112, 112, 1);
        }

        .chinese-box>>>p {
            font-size: 50px;
            font-weight: 400;
            color: black;
        }

        .english-box>>>p {
            font-size: 50px;
            font-weight: 400;
            line-height: 214%;
            color: rgba(153, 153, 153, 1);
        }

        .right-box::after {
            content: 'MORE';
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 35%;
            color: #ffffff;
            font-size: 50px;
            font-weight: 400;
            transform: rotate(-90deg);
            z-index: 3;
            transition: all 0.5s;
        }
    }

    @media(max-width:770px) {
        .caption {
            margin: 2% 0 7% 0;
        }

        .animetionLine {
            display: none;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/home/serve.vue